export function menusError(state, payload){
    state.error = true
    state.errorMessage = payload
    state.menus = ''
    
}
export function setMenus(state, payload){
    state.menus = payload.data.menus
    state.error= false
    state.errorMessage = ''
}
/**
 * metodo llamado desde la vista
 * @param {*} state 
 * @param {*} payload 
 */
export function setMenu(state,payload){
    state.menu = payload
    state.error = false
    state.errorMessage = ''
}
export function setId(state,payload){
    state.menuid = payload.data[0].id
}